import type { ExcursionsComponentProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";

export const Excursions = (props: ExcursionsComponentProps) => {
  return (
    <LazyComponent<ExcursionsComponentProps> name="Excursions" {...props} />
  );
};
